import Vue from "vue";
import Router from "vue-router";
import PageView from "@/layouts/PageView";
import RouteView from "@/layouts/RouteView";
import GlobalLayout from "@/layouts/GlobalLayout";
import Login from "@/pages/login/Login";
// import LoginTwo from "@/pages/login/LoginThree";
import SpacificTransction from '@/pages/transactions/getSpacificTrancation'

Vue.use(Router);

export default new Router({
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      invisible: true
    },
    {
      path: "/",
      name: "Admin",
      component: GlobalLayout,
      redirect: "/login",
      icon: "none",
      invisible: true,
      children: [
        {
          path: "/dashboard/dashboard",
          name: "Admin Dashboard",
          component: () => import("@/pages/dashboard/Dashboard"),
          icon: "dashboard",
          meta: {
            permissions: ["admin"]
          }
        },

        //  {
        //   path: "/dashboard/offers",
        //   name: "offers",
        //   component: () => import("@/pages/offers/offer"),
        //   icon: "table",
        //   meta: {
        //     permissions: ["admin"]
        //   }
        // },

        {
          path: "/movies",
          name: "Movies",
          component: PageView,
          redirect: "/movies/movie",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/movies/movie",
              name: "Movie",
              component: () => import("@/pages/movies/MoviesList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/movies/addmovie/",
              name: "Add Movie Details",
              component: () => import(`@/pages/movies/AddMovieDetails`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/movies/editmovie/:movie_code",
              name: "Edit Movie Details",
              component: () => import(`@/pages/movies/EditMovieDetails`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },
        {
          path: "/ratings",
          name: "Ratings",
          component: PageView,
          redirect: "/ratings/rating",
          icon: "table",
          meta: {
            permissions: ["admin","rating"]
          },
          children: [
            {
              path: "/ratings/rating",
              name: "Ratings",
              component: () => import("@/pages/ratings/RatingsList"),
              icon: "none",
              meta: {
                permissions: ["admin","rating"]
              }
            },
            {
              path: "/rating/editRating/:rating_id",
              name: "Edit Rating Details",
              component: () => import(`@/pages/ratings/EditRating`),
              icon: "none",
              meta: {
                permissions: ["admin","rating"]
              },
              invisible: true
            },
             {
              path: "/rating/addRating",
              name: "Add Rating Details",
              component: () => import(`@/pages/ratings/AddRating`),
              icon: "none",
              meta: {
                permissions: ["admin","rating"]
              },
              invisible: true
            }
          ]
        },
        // Cinemas
        {
          path: "/cinemas",
          name: "Cinemas",
          component: PageView,
          redirect: "/cinemas/cinema",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/cinemas/cinema",
              name: "Cinema",
              component: () => import("@/pages/cinemas/CinemaList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/cinemas/addcinema/:cinema_code",
              name: "Add Cinema Details",
              component: () => import("@/pages/cinemas/AddCinemaDetails"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/cinema/editcinema/:cinema_code",
              name: "Edit Cinema Details",
              component: () => import("@/pages/cinemas/EditCinemaDetails"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },
        // Banner
        {
          path: "/banners",
          name: "Banners",
          component: PageView,
          redirect: "/banners/banner",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/banners/banner",
              name: "Banner",
              component: () => import("@/pages/banners/BannerList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/banners/addbanner",
              name: "Add Banner",
              component: () => import(`@/pages/banners/AddBanner`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/banners/editbanner/:banner_id",
              name: "Edit Banner",
              component: () => import(`@/pages/banners/EditBanner`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },
        {
          path: "/screentypes",
          name: "Screentypes",
          component: PageView,
          redirect: "/screentypes/screentype",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/screentypes/screentype",
              name: "Screentype",
              component: () => import("@/pages/screentypes/ScreentypeList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/screentypes/addscreentype",
              name: "Add Screentype",
              component: () => import(`@/pages/screentypes/AddScreentype`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/screentypes/editscreentype/:screentype_id",
              name: "Edit Screentype",
              component: () => import(`@/pages/screentypes/EditScreentype`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },
        {
          path: "/promotions",
          name: "Promotions",
          component: PageView,
          redirect: "/promotions/promotion",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/promotions/promotion",
              name: "Promotion",
              component: () => import("@/pages/promotions/PromotionList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/promotions/addpromotion",
              name: "Add Promotion",
              component: () => import(`@/pages/promotions/AddPromotion`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/promotions/editpromotion/:promotion_id",
              name: "Edit Promotion",
              component: () => import(`@/pages/promotions/EditPromotion`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/promotions/editpromotion-cards/:promotion_id",
              name: "Edit Promotion Cards",
              component: () => import(`@/pages/promotions/EditPromotionCards`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },


        {
          path: "/ticketTypes",
          name: "Ticket Types",
          component: PageView,
          redirect: "/ticketTypes/ticketType",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/ticketTypes/tickettype",
              name: "Ticket Type",
              component: () => import("@/pages/ticketTypes/TicketTypeList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/ticketTypes/addtickettype",
              name: "Add TicketType",
              component: () => import(`@/pages/ticketTypes/AddTicketType`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/ticketTypes/edittickettype/:tickettype_id",
              name: "Edit TicketType",
              component: () => import(`@/pages/ticketTypes/EditTicketType`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/ticketTypes/editalltickettype",
              name: "Edit All TicketType",
              component: () => import(`@/pages/ticketTypes/EditAllTicketTypes`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/ticketTypes/tickettypegroup",
              name: "Ticket Type Group",
              component: () => import("@/pages/ticketTypes/TicketTypeGroupList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/ticketTypes/addTiecketTypeGroup",
              name: "Add ticket Type Group",
              component: () => import(`@/pages/ticketTypes/AddTicketTypeGroup`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            
          ]
        },



        {
          path: "/vouchers",
          name: "Voucher",
          component: PageView,
          redirect: "/vouchers/voucher",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/vouchers/voucher",
              name: "Voucher",
              component: () => import("@/pages/vouchers/voucherList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            }
          ]
        },
        {
          path: "/tnc",
          name: "Terms And Conditions",
          component: PageView,
          redirect: "/tnc/tnc",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/tnc/tnc",
              name: "TnC",
              component: () => import("@/pages/terms-and-conditions/TncList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/tnc/addtnc",
              name: "Add TnC",
              component: () => import(`@/pages/terms-and-conditions/AddTnc`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/tnc/edittnc/:tnc_id",
              name: "Edit TnC",
              component: () => import(`@/pages/terms-and-conditions/EditTnc`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },
        {
          path: "/receipt-submissions",
          name: "Receipt Submissions",
          component: PageView,
          redirect: "/receipt-submissions/list",
          icon: "table",
          meta: {
            permissions: ["admin", "rs"]
          },
          children: [
            {
              path: "/receipt-submissions/list",
              name: "Receipt Submissions List KSA",
              component: () =>
                import("@/pages/receipts/ListReceiptSubmissions"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            },
            {
              path: "/receipt-submissions/view/:rs_id",
              name: "Edit Receipt Submissions",
              component: () => import(`@/pages/receipts/ViewSingleReceipt`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/receipt-submissions-bh/list",
              name: "Receipt Submissions List BH",
              component: () =>
                import("@/pages/receipts/ListReceiptSubmissionsBh"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            },
            {
              path: "/receipt-submissions-bh/view/:rs_id",
              name: "Edit Receipt Submissions bh",
              component: () => import(`@/pages/receipts/ViewSingleReceiptBh`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/receipt-submissions-dammam-microsite/list",
              name: "Dammam Microsite",
              component: () =>
                import("@/pages/receipts/ListReceiptSubmissionsDammamMicrosite"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            },
            {
              path: "/receipt-submissions-dammam-microsite/view/:rs_id",
              name: "View Dammam Microsite",
              component: () => import(`@/pages/receipts/ViewSingleReceiptDammamMicrosite`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/receipt-submissions-uae-microsite/list",
              name: "Uae Microsite",
              component: () =>
                import("@/pages/receipts/ListReceiptSubmissionsUaeMicrosite"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            },
            {
              path: "/receipt-submissions-uae-microsite/view/:rs_id",
              name: "View Uae Microsite",
              component: () => import(`@/pages/receipts/ViewSingleReceiptUaeMicrosite`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },
        {
          path: "/ksa-questionnaire",
          name: "KSA Questionnaire",
          component: PageView,
          redirect: "/ksa-questionnaire/list",
          icon: "table",
          meta: {
            permissions: ["admin", "rs"]
          },
          children: [
            {
              path: "/ksa-questionnaire/list",
              name: "Questionnaire List",
              component: () =>
                import("@/pages/receipts/ksaQuestionnaireList"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            }
            // ,
            // {
            //   path: "/receipt-submissions/view/:rs_id",
            //   name: "Edit Receipt Submissions",
            //   component: () => import(`@/pages/receipts/ViewSingleReceipt`),
            //   icon: "none",
            //   meta: {
            //     permissions: ["admin"]
            //   },
            //   invisible: true
            // }
          ]
        },
        {
          path: "/bharain-questionnaire",
          name: "BH Comic Con",
          component: PageView,
          redirect: "/bharain-questionnaire/list",
          icon: "table",
          meta: {
            permissions: ["admin", "rs"]
          },
          children: [
            {
              path: "/bharain-questionnaire/list",
              name: "Comic Con List",
              component: () =>
                import("@/pages/receiptsbharain/BharainQuestionnaireList"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            }
            // ,
            // {
            //   path: "/receipt-submissions/view/:rs_id",
            //   name: "Edit Receipt Submissions",
            //   component: () => import(`@/pages/receipts/ViewSingleReceipt`),
            //   icon: "none",
            //   meta: {
            //     permissions: ["admin"]
            //   },
            //   invisible: true
            // }
          ]
        },

        {
          path: "/nue-tel-bh",
          name: "Neutel Bh Emailer",
          component: PageView,
          redirect: "/nue-tel-bh/list",
          icon: "table",
          meta: {
            permissions: ["admin", "rs"]
          },
          children: [
            {
              path: "/nue-tel-bh/list",
              name: "Neutel Bh Emailer",
              component: () =>
              import("@/pages/nuetelbhreceipt/NueTelBhList"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            }
          ]
        },

        {
          path: "/sharjha-questionnaire",
          name: "Sharjah Ent Emailer",
          component: PageView,
          redirect: "/sharjha-questionnaire/list",
          icon: "table",
          meta: {
            permissions: ["admin", "rs"]
          },
          children: [
            {
              path: "/sharjha-questionnaire/list",
              name: "Sharjah Ent Emailer",
              component: () =>
                import("@/pages/sharjharecipts/SharjhaQuestionnaireList"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            }
            // ,
            // {
            //   path: "/receipt-submissions/view/:rs_id",
            //   name: "Edit Receipt Submissions",
            //   component: () => import(`@/pages/receipts/ViewSingleReceipt`),
            //   icon: "none",
            //   meta: {
            //     permissions: ["admin"]
            //   },
            //   invisible: true
            // }
          ]
        },

        // {
        //   path: "/muscat-oman-emailer",
        //   name: "Muscat Oman Emailer",
        //   component: PageView,
        //   redirect: "/muscat-oman-emailer/list",
        //   icon: "table",
        //   meta: {
        //     permissions: ["admin", "rs"]
        //   },
        //   children: [
        //     {
        //       path: "/muscat-oman-emailer/list",
        //       name: "Muscat Oman Emailer",
        //       component: () =>
        //         import("@/pages/muscatomanreceipts/MuscatOmanEmailer"),
        //       icon: "none",
        //       meta: {
        //         permissions: ["admin", "rs"]
        //       }
        //     }
        //   ]
        // },

        {
          path: "/oman-emailer",
          name: "Bogo Oman Offer Mailers",
          component: PageView,
          redirect: "/muscat-oman-emailer/list",
          icon: "table",
          meta: {
            permissions: ["admin", "rs"]
          },
          children: [
            {
              path: "/muscat-oman-emailer/list",
              name: "Muscat Oman Emailer",
              component: () =>
                import("@/pages/muscatomanreceipts/MuscatOmanEmailer"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            },   
            {
              path: "/salalah-oman-emailer/list",
              name: "Salalah Oman Emailer",
              component: () =>
                import("@/pages/salalahomanreceipts/SalalahOmanEmailer"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            },
            {
              path: "/sohar-oman-emailer/list",
              name: "Sohar Oman Emailer",
              component: () =>
                import("@/pages/soharomanreceipts/SoharOmanEmailer"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            }            
          ]
        },

        {
          path: "/massarah-promo-emailer",
          name: "Massarah Promo Emailer",
          component: PageView,
          redirect: "/massarah-promo-emailer/list",
          icon: "table",
          meta: {
            permissions: ["admin", "rs"]
          },
          children: [
            {
              path: "/massarah-promo-emailer/list",
              name: "Massarah Promo Emailer",
              component: () =>
                import("@/pages/massarahreceipts/MassarahPromoEmailer"),
              icon: "none",
              meta: {
                permissions: ["admin", "rs"]
              }
            }
            // ,
            // {
            //   path: "/receipt-submissions/view/:rs_id",
            //   name: "Edit Receipt Submissions",
            //   component: () => import(`@/pages/receipts/ViewSingleReceipt`),
            //   icon: "none",
            //   meta: {
            //     permissions: ["admin"]
            //   },
            //   invisible: true
            // }
          ]
        },
        // Items
        // {
        //   path: "/items",
        //   name: "Items",
        //   component: PageView,
        //   redirect: "/items/item",
        //   icon: "table",
        //   meta: {
        //     permissions: ["admin"]
        //   },
        //   children: [
        //     {
        //       path: "/items/item",
        //       name: "Item",
        //       component: () => import("@/pages/items/ItemsList"),
        //       icon: "none",
        //       meta: {
        //         permissions: ["admin"]
        //       }
        //     },
        //     {
        //       path: "/items/additem/:item_code/:cinema_code",
        //       name: "Add Item Details",
        //       component: () => import(`@/pages/items/AddItemDetails`),
        //       icon: "none",
        //       meta: {
        //         permissions: ["admin"]
        //       },
        //       invisible: true
        //     },
        //     {
        //       path: "/items/edititem/:item_code/:cinema_code",
        //       name: "Edit Item Details",
        //       component: () => import(`@/pages/items/EditItemDetails`),
        //       icon: "none",
        //       meta: {
        //         permissions: ["admin"]
        //       },
        //       invisible: true
        //     }
        //   ]
        // },
        // // Promos
        // {
        //   path: "/promos",
        //   name: "Promos",
        //   component: PageView,
        //   redirect: "/promos/promo",
        //   icon: "table",
        //   meta: {
        //     permissions: ["admin"]
        //   },
        //   children: [
        //     {
        //       path: "/promos/promo",
        //       name: "Promo",
        //       component: () => import("@/pages/promos/PromosList"),
        //       icon: "none",
        //       meta: {
        //         permissions: ["admin"]
        //       }
        //     },
        //     {
        //       path: "/promos/addpromo",
        //       name: "Add Promo",
        //       component: () => import(`@/pages/promos/AddPromo`),
        //       icon: "none",
        //       meta: {
        //         permissions: ["admin"]
        //       },
        //       invisible: true
        //     }
        //     // {
        //     //   path: "/banners/editbanner/:banner_id",
        //     //   name: "Edit Banner",
        //     //   component: () => import(`@/pages/banners/EditBanner`),
        //     //   icon: "none",
        //     //   meta: {
        //     //     permissions: ["admin"]
        //     //   },
        //     //   invisible: true
        //     // }
        //   ]
        // }
        // Users
        {
          path: "/users",
          name: "Users",
          component: PageView,
          redirect: "/users/user",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/users/user",
              name: "User",
              component: () => import("@/pages/users/UserList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/users/edit/:user_id",
              name: "Edit User",
              component: () => import(`@/pages/users/EditUser`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/users/addadmin",
              name: "Add Admin",
              component: () => import(`@/pages/users/AddAdmin`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            }
          ]
        },
        {
          path: "/transactions",
          name: "Transactions",
          component: PageView,
          redirect: "/transactions/transaction",
          icon: "table",
          meta: {
            permissions: ["admin", "ksa_trans", "uae_trans", "omn_trans", "bh_trans","RB"]
          },
          children: [
            {
              path: "/transactions/transaction",
              name: "Transaction",
              component: () => import("@/pages/transactions/TransactionsList"),
              icon: "none",
              meta: {
                permissions: ["admin", "ksa_trans", "uae_trans", "omn_trans", "bh_trans","RB"]
              }
            },
            {
              path: "/transactions/payments",
              name: "Payments",
              component: () => import("@/pages/transactions/PaymentsList"),
              icon: "none",
              meta: {
                permissions: ["admin", "ksa_trans", "uae_trans", "omn_trans", "bh_trans","RB"]
              }
            },
            {
              path: "/transactions/transaction-stats",
              name: "Transactions Stats",
              component: () => import("@/pages/transactions/TransactionsStats"),
              icon: "none",
              meta: {
                permissions: ["admin","RB"]
              },
              
            },
            {
              path: "/transactions/spacificTransction/:id",
              name: "Spacific Tranction",
              component: () => import("@/pages/transactions/getSpacificTrancation"),
              icon: "none",
              meta: {
                permissions: ["admin","RB"]
              },
              invisible: true
            }
          ]
        },
        {
          path: "/fnbs",
          name: "Food and Beverages",
          component: PageView,
          redirect: "/fnbs/category",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/fnbs/category",
              name: "Concession Category",
              component: () => import("@/pages/fnb/ConcessionCategoryList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/fnbs/editConcessionCategory/:cinema_id/:category_id",
              name: "Edit Concession Category",
              component: () => import("@/pages/fnb/EditConcessionCategory"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/fnbs/concessions",
              name: "Concessions",
              component: () => import("@/pages/fnb/ConcessionList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/fnbs/editConcession/:cinema_id/:concession_id",
              name: "Edit Concession",
              component: () => import("@/pages/fnb/EditConcessions"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/fnbs/modifierGroups",
              name: "Modifier Groups",
              component: () => import("@/pages/fnb/ModifierGroupsList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path:
                "/fnbs/editModifierGroups/:cinema_id/:concession_id/:modifier_group_id",
              name: "Edit Modifier Groups",
              component: () => import("@/pages/fnb/EditModifierGroups"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/fnbs/modifiers",
              name: "Modifiers",
              component: () => import("@/pages/fnb/ModifiersList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/fnbs/editModifiers/:cinema_id/:item_id",
              name: "Edit Modifiers",
              component: () => import("@/pages/fnb/EditModifiers"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/fnbs/recipeitems",
              name: "Recipe Items",
              component: () => import("@/pages/fnb/RecipeItemsList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path:
                "/fnbs/editRecipeItems/:cinema_id/:concession_id/:recipe_id",
              name: "Edit Recipe Items",
              component: () => import("@/pages/fnb/EditRecipeItems"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/fnbs/recipemodifiergroups",
              name: "Recipe Modifier Groups",
              component: () => import("@/pages/fnb/RecipeModifierGroupsList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path:
                "/fnbs/editRecipeModifierGroups/:cinema_id/:concession_id/:recipe_id/:recipe_modifier_group_id",
              name: "Edit Recipe Modifier Groups",
              component: () => import("@/pages/fnb/EditRecipeModifierGroups"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
            {
              path: "/fnbs/recipemodifiers",
              name: "Recipe Modifiers",
              component: () => import("@/pages/fnb/RecipeModifiersList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path:
                "/fnbs/editRecipeModifiers/:cinema_id/:concession_id/:recipe_id/:recipe_modifier_group_id/:modifier_id",
              name: "Edit Recipe Modifiers",
              component: () => import("@/pages/fnb/EditRecipeModifiers"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },
        {
          path: "/faqs",
          name: "FAQ's",
          component: PageView,
          redirect: "/faqs/faqs",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
           
            {
              path: "/faqs/faqList",
              name: "FaqList",
              component: () => import("@/pages/faqs/faqsList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
           
        
            {
              path: "/faqs/addFaq",
              name: "AddFaq",
              component: () => import("@/pages/faqs/addFaq"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            },
           
            {
              path: "/faqs/editfaq/:faq_id",
              name: "EditFaq",
              component: () => import(`@/pages/faqs/EditFaq`),
              icon: "none",
              meta: {
                permissions: ["admin"]
              },
              invisible: true
            }
          ]
        },
        // Book Event
        {
          path: "/bookedEvent",
          name: "Event",
          component: PageView,
          redirect: "/bookedEvent/bookedEventList",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/bookedEvent/bookedEventList",
              name: "Booked Event",
              component: () => import("@/pages/bookedEvent/bookedEventList"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            },
            {
              path: "/bookedEvent/AddEventType",
              name: "Event Type",
              component: () => import("@/pages/bookedEvent/AddEventType"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            }
          ]
        },
        {
          path: "/cron",
          name: "Cron",
          component: PageView,
          redirect: "/crons/cron",
          icon: "table",
          meta: {
            permissions: ["admin"]
          },
          children: [
            {
              path: "/crons/cron",
              name: "Manual Crone",
              component: () => import("@/pages/crons/croneshow"),
              icon: "none",
              meta: {
                permissions: ["admin"]
              }
            }
          ]
        },
        // Others
        // {
        //   path: '/exception',
        //   name: 'Exception',
        //   icon: 'warning',
        //   component: RouteView,
        //   children: [
        //     {
        //       path: '/exception/404',
        //       name: '404',
        //       icon: 'none',
        //       component: () => import('@/pages/exception/404')
        //     },
        //     {
        //       path: '/exception/403',
        //       name: '403',
        //       icon: 'none',
        //       component: () => import('@/pages/exception/403')
        //     },
        //     {
        //       path: '/exception/500',
        //       name: '500',
        //       icon: 'none',
        //       component: () => import('@/pages/exception/500')
        //     }
        //   ]
        // },
      ]
    },
    {
      path: "/get-spacific-trascation",
      name: "Login",
      component: Login,
      invisible: true
    },
  ]
});
